import { useEffect, useState } from 'react';

export const MOBILE_MAX_WIDTH = 767;

export function useIsMobile(): boolean {
    const [isMobile, setIsMobile] = useState(() => {
        if (typeof window === 'undefined') {
            return false;
        }
        return window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`).matches;
    });

    useEffect(() => {
        const query = window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`);
        const sync = () => setIsMobile(query.matches);

        sync();
        query.addEventListener('change', sync);
        return () => query.removeEventListener('change', sync);
    }, []);

    return isMobile;
}
